<template>
  <div class="h-screen flex flex-col">
    <DefaultMenu />
    <div class="flex-grow">
      <slot />
    </div>
    <!-- <div class="min-h-fit">
      <Footer></Footer>
    </div> -->
  </div>
</template>

<script lang="ts">
import DefaultMenu from "@/layouts/DefaultMenu.vue";
import Footer from "@/layouts/Footer.vue";

import { defineComponent } from "vue";


export default defineComponent({
  name: "EmptyLayout",
  components: {
    DefaultMenu,
    Footer,
  },
  mounted(){
    
  }
});
</script>
